export default {"src":"/login-app/[GIT_HASH]/_next/static/media/cursor.dd122dc4.svg","height":532,"width":467,"blurWidth":0,"blurHeight":0};